<template>
  <popup ref="popup" :loading="popupLoading" :appendToBody="true">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px"
        :rules="rules">
        <el-row>
          <el-col :span="16">
            <el-form-item label="标题" prop="title"><el-input v-model="formParameter.title" autocomplete="off"
                placeholder="标题"></el-input></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="绑定科目" prop="duration">
              <el-input placeholder="请选择科目" disabled v-model="sbname">
                <template slot="append">
                  <el-button type="primary" @click="selectSub">{{ sbname ? '重选' : '选择' }}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row  v-if="type==4">
          <el-col :span="24">
            <el-form-item label="代码" prop="url">
              <excel-Upload  v-if="(!disabled)" drag v-model="formParameter.url" size="32768" model="fileSystem" uri="/statics/codes"
                  v-on:change="callBackCodesUrl"></excel-Upload>
                <ul>
                    <li>【压缩包】小于:32MB,请不要使用中文命名文件名</li>
                    <li v-if="formParameter.url">{{ formParameter.url }}
                        <el-button :disabled="false" type="success" size="mini" @click="download">下载代码</el-button> </li>
                   
                </ul>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="所属网站" v-if="type == 2" prop="vsite">
              <select-option-dictionary v-model="formParameter.vsite" dkey="vsite"> </select-option-dictionary>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="录制时间" v-if="type == 2" prop="vtm">
              <el-date-picker v-model="formParameter.vtm" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="类型" v-if="type == 2" prop="types">
              <select-option-dictionary v-model="formParameter.types" dkey="videoes-types"> </select-option-dictionary>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="时长" v-if="type == 2" prop="duration">
              <el-input v-model="formParameter.duration" autocomplete="off" placeholder="单位分钟"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col v-if="type < 3" :span="24">
            <el-form-item label="URL网址" prop="url"><el-input v-model="formParameter.url" autocomplete="off"
                placeholder="网址"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="type == 3 ? '授课笔记' : '摘要'" prop="remarks">
              <span v-if="disabled" v-html="formParameter.remarks"></span>
              <wang-edit v-else v-model="formParameter.remarks" :isupdt="wangEditisupdt"></wang-edit>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-dialog title="选择绑定科目" :visible.sync="dialogVisible" width="60%" :append-to-body="true">
        <tree class="filter-tree" ref="permissionTree" check-strictly :items="subjectList" :data="subjectList"
          :defaultParent="0" @nodeClick="treeClick" :expand-on-click-node="true"> </tree>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="comfirmSub">选定科目</el-button>
        </span>
      </el-dialog>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
      <el-button @click="close">关 闭</el-button>
    </div>
  </popup>
</template>
 
<script>
import popup from '@/components/popup/drawerPopup.vue'
import api from '@/api/edu/videoes/videoes.js'
import subApi from '@/api/edu/subject/subject.js'
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue'
import wangEdit from "@/components/wangEdit/wangEdit.vue";
import excelUpload from "@/components/biz/fileUpload/excelUpload.vue";
import tree from '@/components/tree/tree.vue'
import constant from '@/util/constant.js';
import caches from "util/caches.js";

export default {
  name: 'edit',
  components: {
    popup,
    selectOptionDictionary,
    wangEdit,
    tree,
    excelUpload
  },
  data() {
    return {
      type: '2',
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      baseUrl: constant.serverUrl + "/",
      parameter: {},
      formParameter: { vsite: 1 },

      sbname: '', //科目名称
      dialogVisible: false, //科目弹框开关
      subData: [], //选中的科目信息
      //---树--选择题型 模态框弹出为false
      innerVisible: false,
      // 树 的最后一个的id集
      subIds: [],
      subjectList: null,
      orgsubjectList: null,

      wangEditisupdt: false,
      parent: false,

      listExam: [],
      rules: {
        //视频标题
        title: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 255,
            trigger: 'blur'
          }
        ],
        // 网址
        url: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          }
        ],
        // 类型(1.基础教学，2.难点答疑，3.项目操作)
        types: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 1,
            trigger: 'blur'
          }
        ],
      }
    }
  },
  methods: {
    download(){
      let tokenVal = caches.token.get();
      console.log("tokenVal",tokenVal)
      api.downCodes(null, { url:this.formParameter.url },{ token: tokenVal })
    },
    callBackCodesUrl(fname){
      if (fname) {
        this.formParameter.url =  fname.substring(fname.lastIndexOf("/statics/codes"));
      }
    },
    // 选择科目
    selectSub() {
      this.dialogVisible = true

      if (!this.orgsubjectList) {
        subApi.list({}, response => {
          this.orgsubjectList = response.data
          this.subjectList = this.orgsubjectList
        })
      } else {
        this.subjectList = this.orgsubjectList
      }

    },
    // 选择科目
    treeClick(data) {
      this.subData = data
    },
    comfirmSub() {

      this.sbname = this.subData.name
      this.formParameter.kid = this.subData.id

      this.dialogVisible = false
    },  //从subject打开弹框
    openInShow(parameter, type, disabled, parent) {

      this.type = type
      let title = '添加 - ' + (type == 1 ? '技术文档' : (type == 2 ? '授课视频' : (type == 3 ? '课堂笔记' : '代码附件')))
      this.disabled = disabled
      this.parent = parent
      this.$refs.popup.open(title)

      if (this.type == 1) {
        this.formParameter = { vsite: 1 }
        this.$refs.popup.open(title);
      }else if(this.type == 3){
        this.$refs.popup.open(title, 1380);
      }

      setTimeout(() => {
        this.wangEditisupdt = false
        let eds = document.getElementsByClassName('w-e-text-container')
        if (this.type == 3) {
          eds[0].style = eds[0].style.cssText + 'height: 700px'
        }else{
          eds[0].style = eds[0].style.cssText + 'height: 300px'
        }
      }, 100)

      subApi.list({}, response => {
        this.orgsubjectList = response.data
        this.subjectList = this.orgsubjectList
        this.formParameter.kid = parameter.kid
        this.sbname = parameter.name
        this.$forceUpdate();
      })

    },
    //打开弹框
    open(parameter, type, disabled, parent, size) {

      this.wangEditisupdt = true

      this.type = type
      let title = (disabled ? "查看 - " : (parameter.id ? '修改 - ' : '添加 - ')) + (type == 1 ? '技术文档' : (type == 2 ? '授课视频' : (type == 3 ? '学习笔记' : '附件')))
 
      this.parameter = parameter
      this.disabled = disabled
      this.parent = parent
      this.$refs.popup.open(title, 1600);

      setTimeout(() => {
        this.wangEditisupdt = false
        let eds = document.getElementsByClassName('w-e-text-container')
        if (this.type == 3) {
          eds[0].style = eds[0].style.cssText + 'height: 700px'
        }else{
          eds[0].style = eds[0].style.cssText + 'height: 300px'
        }
      }, 100)

      this.$nextTick(() => {
        this.init()
      })
    },
    //关闭弹框
    close() {
      this.disabled = false

      this.sbname = ""
      this.formParameter = { vsite: 1 }
      this.$refs.popup.close()
    },
    //提交表单
    confirm() {

      if(!this.formParameter.kid){
          this.$utils.msg.warning("科目必选")
          return;
      }

      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true
        if (!this.parameter.id) {
          //添加
          let parameter = this.$utils.merger(this.formParameter)
          parameter.type = this.type
          api.save(
            parameter,
            response => {
              this.$utils.msg.success(response.msg)
              this.confirmLoading = false
              this.close()
              //  console.log(" this.$parent ", this.$parent)
              this.parent.list()
            },
            response => {
              this.$utils.msg.warning(response.msg)
              this.confirmLoading = false
            }
          )
        } else {
          //编辑
          let parameter = this.$utils.merger(this.formParameter)
          parameter.type = this.type
          api.update(
            parameter,
            response => {
              this.$utils.msg.success(response.msg)
              this.confirmLoading = false
              this.close()
              this.parent.list()
            },
            response => {
              this.$utils.msg.warning(response.msg)
              this.confirmLoading = false
            }
          )
        }
      })
    },
    init() {
      this.popupLoading = true
      //清除等待
      this.confirmLoading = false
      //清空内容
      this.formParameter = { vsite: 1 }
      if (this.type == 1) {
        this.formParameter.types = 5  //'技术文档'
      }
      //清楚校验
      this.$refs.form.clearValidate()

      if (this.parameter && this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id
        }
        api.toUpdate(parameter, response => {
          this.popupLoading = false
          console.log(response)
          this.formParameter = response.data

          if (this.formParameter.kid) {
            this.sbname = this.formParameter.dbColumn_kid
          }
          this.popupLoading = false
        })
      } else {
        //添加
        this.popupLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
